export const resultStrings = {
  Agency: { key: 'agencies', title: 'Agencies' },
  Artwork: { key: 'artworks', title: 'Artworks' },
  ArtworkPage: { key: 'artworkPages', title: 'Artwork Pages' },
  Campaign: { key: 'campaigns', title: 'Campaigns' },
  CampaignProposal: { key: 'campaignProposals', title: 'Campaign Proposals' },
  CampaignQuote: { key: 'campaignQuote', title: 'Quotes' },
  CampaignQuoteTemplate: { key: 'campaignQuoteTemplates', title: 'Quote Templates' },
  DigitalPage: { key: 'digitalPages', title: 'Digital Pages' },
  Invoice: { key: 'invoices', title: 'Invoices' },
  Order: { key: 'orders', title: 'Orders' },
  OrderItem: { key: 'orderItems', title: 'Order Items' },
  Provider: { key: 'providers', title: 'Providers' },
  TemplatePage: { key: 'templatePages', title: 'Template Pages' },
  User: { key: 'users', title: 'Users' },
}

export default resultStrings
